import { CalendarAltIcon } from "assets/icons";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DateInput, FormField, TimeInput } from "ui";

import { NotificationFormValues } from "../NotificationForm.types";

import styles from "../NotificationForm.module.scss";

export const PostingDateFields = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<NotificationFormValues>();

  return (
    <div className={styles.form_twoColumnsBlock}>
      <Controller
        control={control}
        name={"postingDate"}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <FormField
            label={t("Posting date")}
            labelClassName={styles.form_fieldLabel}
            errorMessage={error?.message}
          >
            <DateInput
              value={value}
              onChange={onChange}
              calendarIcon={<CalendarAltIcon />}
            />
          </FormField>
        )}
      />

      <Controller
        control={control}
        name={"postingTime"}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <FormField
            label={t("Posting time")}
            labelClassName={styles.form_fieldLabel}
            errorMessage={error?.message}
          >
            <TimeInput value={value} onChange={onChange} />
          </FormField>
        )}
      />
    </div>
  );
};
